import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { TradesPageContext } from "@shared/features/trades/common/TradesPage.context";
import { useBottomNavigator } from "utils/hooks/misc";
import useClosedTradesStatistics from "features/trades/ClosedTrades/useClosedTradesStatistics.tsx";

const ClosedTradesStatistics = () => {
  const theme = useTheme();
  const { isLoading, isFetching, inDrawer } = useContext(TradesPageContext)!;
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { closedTradesStatistic, totalChangeStatistic } =
    useClosedTradesStatistics();

  const content = (
    <LoadingSpinnerOverlay
      isLoading={isLoading || (!isBottomNavigator && isFetching)}
      backgroundColor={theme.colors.cardBgColor}
    >
      {!inDrawer && closedTradesStatistic}
      {totalChangeStatistic}
    </LoadingSpinnerOverlay>
  );

  return (
    <Wrapper
      style={inDrawer ? { width: "fit-content", margin: "0 auto" } : undefined}
    >
      {content}
    </Wrapper>
  );
};

export default ClosedTradesStatistics;

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  position: relative;
  height: 100%;
`;
